module.exports = __webpack_public_path__ + "media/components/assets/images/children_together-0360bce6ed7a3bd6c0dfea1b34eb8cb3.png";